import {
    useDeleteLoyaltyConfigMutation,
    useLazyGetLoyaltyProgramsQuery,
} from '@/services/innovorder/modules/modules.endpoints';

import { useGetLoyaltyConfigQuery } from '@/services/innovorder/modules/modules.endpoints';
import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';

const useComoLoyaltyIntegrationVM = () => {
    const { restaurantId } = useParams<{ restaurantId: string; brandId: string }>();
    const [deleteConfig, { isLoading: isDeleting, isSuccess: isDeleteSuccess }] = useDeleteLoyaltyConfigMutation();
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

    const [getLoyaltyProgram, { data: loyaltyPrograms, isLoading: isLoadingLoyaltyPrograms }] =
        useLazyGetLoyaltyProgramsQuery();
    const {
        data: loyaltyConfig,
        error,
        isLoading,
    } = useGetLoyaltyConfigQuery({
        restaurantId: Number(restaurantId),
    });
    const hasComoConfig = useMemo(() => {
        if (error) {
            return false;
        }
        getLoyaltyProgram({ restaurantId: Number(restaurantId) });
        return loyaltyConfig?.provider === 'como';
    }, [loyaltyConfig, error]);

    useEffect(() => {
        if (isDeleteSuccess) {
            setIsModalOpen(false);
        }
    }, [isDeleteSuccess]);

    return {
        hasComoConfig,
        loyaltyConfig,
        loyaltyPrograms,
        isLoading,
        isDeleting,
        isModalOpen,
        setIsModalOpen,
        deleteConfig,
        isLoadingLoyaltyPrograms,
    };
};

export default useComoLoyaltyIntegrationVM;
